import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Properties for the Confluence submit prompt on page create command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to submit a prompt.
 *
 * @summary {@link CommandProperties.senderId} sends the user prompt to {@link CommandProperties.receiverId} once per page creation.
 */
export var ConfluenceSubmitPromptOnPageCreateCommand = createCommand('confluence-prompt-submit-on-page-create-command');